module.exports = __webpack_public_path__ + "img/jeremy-pro.2b686451.jpg";